
import Moment from 'moment';

const routeData1 = {
  type: 'FeatureCollection',
  features: [
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [237.56, 37.78],
      },
      properties: {
        description: 'San Francisco, USA',
        airportCode: 'OAK',
        date: new Moment('2018-05-22 07'),
        anchor: 'right',
        airline: 'British Airways',
        flightNumber: '321',
        price: '600.00',
        class: 'Economy',
        seatGuruRanking: 'A+',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [151.175, -33.94],
      },
      properties: {
        description: 'Sydney, Australia',
        airportCode: 'SYD',
        date: new Moment('2018-05-22 15'),
        anchor: 'left',
        airline: 'British Airways',
        flightNumber: '321',
        price: '600.00',
        class: 'Economy',
        seatGuruRanking: 'A+',
      },
    },
  ],
};

const routeData1_return = {
  type: 'FeatureCollection',
  features: [
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [151.175, -33.94],
      },
      properties: {
        description: 'Sydney, Australia',
        airportCode: 'SYD',
        date: new Moment('2018-05-22 15'),
        anchor: 'left',
        airline: 'British Airways',
        flightNumber: '321',
        price: '600.00',
        class: 'Economy',
        seatGuruRanking: 'A+',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [237.56, 37.78],
      },
      properties: {
        description: 'San Francisco, USA',
        airportCode: 'OAK',
        date: new Moment('2018-05-22 07'),
        anchor: 'right',
        airline: 'British Airways',
        flightNumber: '321',
        price: '600.00',
        class: 'Economy',
        seatGuruRanking: 'A+',
      },
    },
  ],
};

const slideData = [routeData1, routeData1_return];

export default slideData;



// WEBPACK FOOTER //
// ./src/tripData3.js